import React, { useEffect, useMemo, useState } from "react";
import { MwButton } from "../ui";
import { useCurrent, useFetch, usePost } from "../../hooks";
import CardHeadeWithActions from "../ui/CardHeadeWithActions";
import BasicInfoForm from "./forms/BasicInfoForm";
import ResponsiblesForm from "./forms/ResponsiblesForm";
import AddressForm from "./forms/AddressForm";
import AdvancedForm from "./forms/AdvancedForm";
import { langObjType, objLangTextHandler } from "../../utils/global";
import { getAllSalesman } from "../../services/salesmanService";
import { useTranslation } from "react-i18next";
import { invalidateFetchCache } from "../../hooks/useFetch";

const CreateCustomer = ({ onHide, onCustomerCreated = () => {}, setMode }) => {
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangList, currentLangId } =
    useCurrent();
  const [t] = useTranslation("global");
  const [errors, setErrors] = useState({});
  const [tabActive, setTabActive] = useState("TabOne");
  const { data: resultPost, postData } = usePost();

  const [fullname, setFullname] = useState(langObjType());
  const [customerNo, setCustomerNo] = useState("");
  const [groupSelected, setGroupSelected] = useState([]);
  const [mobileNo, setMobileNo] = useState("");
  const [phoneNo, setPhoneNo] = useState();
  const [email, setEmail] = useState("");
  const [customerNotes, setCustomerNote] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [customerType, setCustomerType] = useState();
  const [paymentDuringDays, setPaymentDuringDays] = useState();
  const [salesmanSelected, setSalesmanSelected] = useState();

  const [listPriceSelected, setListPriceSelected] = useState();
  const [listPrice, setListPrice] = useState([]);
  const { data: resultPriceList } = useFetch(
    `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/inventory/list-price/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );

  const [responsibles, setResponsibles] = useState([]);
  const [address, setAddress] = useState([]);

  const [customerAccountNo, setCustomerAccountNo] = useState();
  const [customerVatNo, setCustomerVatNo] = useState();
  const [customerCr, setCustomerCr] = useState();
  const [limitCredit, setLimitCredit] = useState();

  const customerTypes = useMemo(
    () => [
      { value: 1, translations: { ar: "شركات", en: "Company" } },
      { value: 2, translations: { ar: "افراد", en: "Individuals" } },
    ],
    []
  );
  const custTypesList = useMemo(
    () =>
      customerTypes.map((type) => ({
        label: type.translations[currentLangId] || type.translations.en,
        value: type.value,
        lang: currentLangId,
      })),
    [customerTypes, currentLangId]
  );

  const [_salesmansList, _setSalesmanList] = useState([]);
  useEffect(() => {
    const loadSalesmans = async () => {
      const list = await getAllSalesman(
        currentTenantId,
        currentCompanyId,
        currentBranchId
      );
      _setSalesmanList(list || []);
    };
    loadSalesmans();
  }, [currentTenantId, currentCompanyId, currentBranchId]);

  useEffect(() => {
    if (resultPriceList?.data) {
      const _list =
        resultPriceList.data?.map((item) => ({
          label: item.name,
          value: item.id,
          lang: currentLangId,
        })) || [];
      setListPrice(_list);
    }
  }, [resultPriceList, currentLangId]);

  const formValidate = () => {
    let errorObj = {};

    if (!fullname[currentLangId]) {
      errorObj = {
        ...errorObj,
        [`fullname.${currentLangId}`]: t("customers.nameRequired"),
      };
    }

    if (mobileNo && isNaN(mobileNo)) {
      errorObj.mobileNo = t("customers.mobileMustBeNumber");
    }

    if (Object.keys(errorObj).length !== 0) {
      setErrors(errorObj);
      return true;
    }
    return false;
  };

  const saveHandler = async () => {
    if (formValidate()) {
      return;
    }
    const _data = {
      fullname: objLangTextHandler(fullname),
      customerNo,
      mobileNo,
      phoneNo,
      email,
      customerNotes,
      limitCredit,
      customerAccountNo,
      customerVatNo,
      cutomer_cr: customerCr,
      customerGroupsIds: groupSelected.map((el) => el.value),
      responsibles,
      customerAddresses: address,
      customerType: customerType?.value,
      paymentDuringDays,
      salesmanId: salesmanSelected?.value,
      listPriceId: listPriceSelected?.value,
      isActive,
      tenantId: currentTenantId,
      companyId: currentCompanyId,
      branchId: currentBranchId,
    };

    postData(`${process.env.REACT_APP_Auth_API_BASE_URL}/customers`, _data);
  };

  const cancelHandle = () => {
    onHide();
  };

  useEffect(() => {
    if (resultPost) {
      const customersListUrl =
        currentTenantId && currentCompanyId && currentBranchId
          ? `${process.env.REACT_APP_Auth_API_BASE_URL}/customers/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
          : null;
      invalidateFetchCache(customersListUrl);
      onHide ? cancelHandle() : setMode("List");
      onCustomerCreated();
    }
  }, [
    resultPost,
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    onHide,
    setMode,
    onCustomerCreated,
  ]);

  return (
    <div className={`${onHide && "p-5"}`}>
      <CardHeadeWithActions title={t("customers.addNewCustomer")}>
        {onHide && (
          <MwButton inGroup={true} type="cancelBtn" onClick={cancelHandle}>
            {t("customers.cancel")}
          </MwButton>
        )}
        <MwButton inGroup={true} type="cancelBtn" onClick={() => setMode("List")}>
          {t("customers.manageCustomers")}
        </MwButton>
        <MwButton
          actionType={`button`}
          inGroup={true}
          onClick={saveHandler}
          type="saveBtn"
        >
          {t("customers.save")}
        </MwButton>
      </CardHeadeWithActions>
      <form>
        <div className=" bg-slate-50 rounded-lg text-xs p-3 flex flex-col gap-1">
          <ul className="flex gap-3 items-centers list-none">
            <li
              onClick={() => setTabActive("TabOne")}
              className={`cursor-default rounded px-2 py-1 hover:font-bold ${
                tabActive === "TabOne" ? "bg-indigo-100 font-bold" : "bg-slate-100"
              }`}
            >
              {t("customers.basicInfo")}
            </li>
            <li
              onClick={() => setTabActive("TabTwo")}
              className={`cursor-default rounded px-2 py-1 hover:font-bold ${
                tabActive === "TabTwo" ? "bg-indigo-100 font-bold" : "bg-slate-100"
              }`}
            >
              {t("customers.responsibleData")}
            </li>
            <li
              onClick={() => setTabActive("TabThree")}
              className={`cursor-default rounded px-2 py-1 hover:font-bold ${
                tabActive === "TabThree"
                  ? "bg-indigo-100 font-bold"
                  : "bg-slate-100"
              }`}
            >
              {t("customers.addresses")}
            </li>
            <li
              onClick={() => setTabActive("TabFour")}
              className={`cursor-default rounded px-2 py-1 hover:font-bold ${
                tabActive === "TabFour"
                  ? "bg-indigo-100 font-bold"
                  : "bg-slate-100"
              }`}
            >
              {t("customers.advancedData")}
            </li>
          </ul>
          {tabActive === "TabOne" && (
            <BasicInfoForm
              _salesmansList={_salesmansList}
              custTypesList={custTypesList}
              customerType={customerType}
              setCustomerType={setCustomerType}
              salesmanSelected={salesmanSelected}
              setSalesmanSelected={setSalesmanSelected}
              currentTenantId={currentTenantId}
              currentCompanyId={currentCompanyId}
              currentBranchId={currentBranchId}
              currentLangId={currentLangId}
              currentLangList={currentLangList}
              errors={errors}
              customerNo={customerNo}
              setCustomerNo={setCustomerNo}
              groupSelected={groupSelected}
              setGroupSelected={setGroupSelected}
              fullname={fullname}
              setFullname={setFullname}
              mobileNo={mobileNo}
              setMobileNo={setMobileNo}
              phoneNo={phoneNo}
              setPhoneNo={setPhoneNo}
              email={email}
              setEmail={setEmail}
              customerNotes={customerNotes}
              setCustomerNote={setCustomerNote}
              isActive={isActive}
              setIsActive={setIsActive}
            />
          )}
          {tabActive === "TabTwo" && (
            <ResponsiblesForm
              currentLangId={currentLangId}
              currentLangList={currentLangList}
              errors={errors}
              responsibles={responsibles}
              setResponsibles={setResponsibles}
            />
          )}
          {tabActive === "TabThree" && (
            <AddressForm errors={errors} address={address} setAddress={setAddress} />
          )}
          {tabActive === "TabFour" && (
            <AdvancedForm
              errors={errors}
              customerAccountNo={customerAccountNo}
              setCustomerAccountNo={setCustomerAccountNo}
              customerVatNo={customerVatNo}
              setCustomerVatNo={setCustomerVatNo}
              customerCr={customerCr}
              setCustomerCr={setCustomerCr}
              limitCredit={limitCredit}
              setLimitCredit={setLimitCredit}
              paymentDuringDays={paymentDuringDays}
              setPaymentDuringDays={setPaymentDuringDays}
              listPriceSelected={listPriceSelected}
              setListPriceSelected={setListPriceSelected}
              listPrice={listPrice}
            />
          )}
        </div>
      </form>
    </div>
  );
};

export default CreateCustomer;
